import { List, Filters } from "colbi_web_ui/lib/components";
import React from "react";
import { mapProjectsByOrganization } from "../../utils/mapProjectsByOrganization";
import theme from "../../style/_theme.json";
import ExportButton from "../ExportButton/ExportButton";
import { parseFilter, stringifyFilter } from "colbi_web_ui/lib/utils";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "./AggregateDataList.module.sass";
import HeatMap from "colbi_web_ui/lib/components/HeatMap/HeatMap";
import { REACT_APP_COLBI_THEME } from "../../environmentVariables";
import Spinner from "colbi_web_ui/lib/components/Spinner/Spinner";
import { mapSelectedCalendarType } from "../../utils/date";
import { mapMetadataToHeatMap } from "../../utils/mapMetadata";

const ProjectRow = ({ data }, organizationModules) => {
    const appTheme = REACT_APP_COLBI_THEME ? REACT_APP_COLBI_THEME.toLocaleLowerCase() : "sovos";
    const { i18n } = useGlobalValue();

    const heatMapList = mapMetadataToHeatMap(
        data.aggregationDataResult,
        data.yearType || "fiscalyear",
        data.selectedYear || "N/A",
    );

    return (
        <div className={styles["project"]}>
            <div className={styles["project-row"]}>
                <h5>{`${data.taxRegistrationNumber} - ${data.name} `}</h5>
                <div>
                    <small
                        className={`${styles["status"]} ${styles[`status-${data.projectExpired}`]}`}
                    >
                        {i18n(`status-project-${data.projectExpired}`)}
                    </small>
                </div>
                <div className={styles["fiscal-years-container"]}>
                    <small>{` ${Object.keys(data.fiscalYears).join(", ")} `}</small>
                </div>
                <h5 className={styles[`is-active`]}>
                    <small className={styles[`is-active-${data.active}`]}>
                        {i18n(`${data.active} | isactive`)}
                    </small>
                </h5>
                {(organizationModules || []).find(
                    (element) => element === "aggregate_org_data",
                ) && (
                    <HeatMap
                        heatMapList={heatMapList}
                        fiscalYear={data.selectedYear}
                        type="colorHeatMap"
                        theme={appTheme}
                    />
                )}
            </div>
        </div>
    );
};

const renderAggregateDataList = (
    organization,
    filter,
    i18n,
    params,
    organizationModules,
    resultFilters,
    yearTypeName,
    yearName,
) => {
    if (!organization) {
        return <></>;
    }

    const { organizationId, locale } = params || {};

    const showPeriodsColumn = (organizationModules || []).find(
        (element) => element === "aggregate_org_data",
    );
    const verifiedFilter = filter ? stringifyFilter(parseFilter(filter)) : null;

    const projectsToShowInTheList =
        mapProjectsByOrganization(
            organization,
            undefined,
            yearName,
            mapSelectedCalendarType(yearTypeName),
        ) || [];

    const numberOfProjects = (projectsToShowInTheList || []).length;
    const listFooter = i18n`${numberOfProjects} of ${numberOfProjects}`;

    const heatMapLabel = showPeriodsColumn
        ? [
              {
                  label: [i18n`${yearTypeName} ${yearName}`],
                  type: "heatMapPeriods",
              },
          ]
        : [];

    return (
        <List
            modifiers={["--row-style-alternate"]}
            headerListComponent={[
                {
                    component: Filters,
                    props: {
                        filter: verifiedFilter,
                        availableFilters:
                            resultFilters && showPeriodsColumn
                                ? resultFilters
                                : (resultFilters || []).filter(
                                      (elem) => !["period", "submission"].includes(elem.prop),
                                  ),
                        stickyTop: theme,
                        anchor: "results",
                    },
                },
                {
                    component: ExportButton,
                    props: {
                        data: projectsToShowInTheList,
                        alternativeQueryData: [
                            {
                                resource: "organization_projects_export",
                                args: {
                                    locale: `${locale}`,
                                    organizationId: `${organizationId}`,
                                    organizationMaxFiscalYear: yearName || `${yearName}`,
                                    filter: params.filter
                                        ? {
                                              type: "[FilterInput!]",
                                              value: parseFilter(params.filter),
                                          }
                                        : undefined,
                                    yearType: mapSelectedCalendarType(yearTypeName),
                                },
                                body: `report`,
                                downloadable: true,
                                downloadOnly: true,
                                xlsxTranslation: "organizations_projects",
                            },
                        ],
                    },
                },
            ]}
            header={[
                { label: [`${i18n`TRN`} - ${i18n`Project`}`], basis: "22.5%" },
                { label: [i18n`Status`], columnName: "period", align: "center" },
                { label: [i18n`Fiscal Years`], columnName: "period", align: "right" },
                { label: [i18n`Active`], align: "center" },
                ...heatMapLabel,
            ]}
            items={projectsToShowInTheList}
            card={(data) => ProjectRow(data, organizationModules)}
            footer={[listFooter]}
        />
    );
};

const AggregateDataList = ({
    year,
    yearType,
    organizationProjects,
    filter,
    i18n,
    params,
    organizationModules,
    resultFilters,
}) => {
    const { name: yearName } = year || {};
    const { name: yearTypeName } = yearType || {};

    return (
        <>
            {organizationProjects && organizationModules ? (
                renderAggregateDataList(
                    organizationProjects,
                    filter,
                    i18n,
                    params,
                    organizationModules,
                    resultFilters,
                    yearTypeName,
                    yearName,
                )
            ) : (
                <Spinner />
            )}
        </>
    );
};

export default AggregateDataList;
